import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { Observable, of } from 'rxjs';

import { Catalog } from '@app/core/business/catalog/catalog';

import { environment } from '@env/environment';
import { delay } from 'rxjs/operators';
import { CacheService } from '../product/cache.service';
import { ProductAvailability } from '../product/product-availability';

@Injectable({
  providedIn: 'root',
})
export class CatalogService {
  private baseUrl: string = environment.baseApiUrl;

  //#region
  private catalogsMock: Catalog[] = [
    {
      label: 'Produits frais',
      products: [
        {
          code: '1',
          displayCode: '1',
          ean: '5 901234 123457',
          brand: 'Best',
          brandUrl: 'www.google.com',
          label: 'Apple',
          fullLabel: 'Best Apple',
          pictures: [
            {
              url:
                'https://bestapples.com/wp-content/uploads/2018/01/ambrosia-apple.jpg',
              alt: 'Apple 1',
            },
            {
              url:
                'https://storage.googleapis.com/zopnow-static/images/products/320/fresh-apple-red-delicious-v-500-g.png',
              alt: 'Apple 2',
            },
          ],
          origin: 'France',
          isFavorite: true,
          discount: false,
          unpackedQuantity: 2,
          allergens: [],
          ingredients: '',
          documents: [],
          outer: 10,
          weight: {
            gross: '126',
            unit: 'g',
          },
          price: [
            {
              minQuantity: '0',
              maxQuantity: '100',
              price: {
                gross: '1,00',
                unit: '€',
                freeDeliveryMinimum: '200,00',
                taxes: ['0,20'],
              },
            },
          ],
          availability: {
            availability: 2,
            text: ''
          },
          availabilityRefreshRate: 500
        },
        {
          code: '2',
          displayCode: '2',
          ean: '5 921234 123458',
          brand: 'Best',
          brandUrl: 'www.google.com',
          label: 'Orange',
          fullLabel: 'Best Orange',
          pictures: [
            {
              url:
                'https://www.djiboutifresh.com/wp-content/uploads/2017/07/orange.jpg',
              alt: 'Orange 1',
            },
            {
              url: 'https://www.espaceagro.com/_AFFAIRE/291081.jpg',
              alt: 'Orange 2',
            },
          ],
          origin: 'France',
          isFavorite: false,
          discount: false,
          allergens: [],
          ingredients: '',
          documents: [],
          outer: 5,
          weight: {
            gross: '96',
            unit: 'g',
          },
          price: [
            {
              minQuantity: '0',
              maxQuantity: '100',
              price: {
                gross: '1,00',
                unit: '€',
                freeDeliveryMinimum: '200,00',
                taxes: ['0,20'],
              },
            },
          ],
          availability: {
            availability: 1,
            text: '',
          },
          availabilityRefreshRate: 500
        },
        {
          code: '3',
          displayCode: '3',
          ean: '5 921234 123458',
          brand: 'Best',
          brandUrl: 'www.google.com',
          label: 'Melon',
          fullLabel: 'Best Melon',
          pictures: [
            {
              url:
                'https://www.jacques-briant.fr/6253-large_default/melon-stellio.jpg',
              alt: 'Melon 1',
            },
            {
              url:
                'http://cdn.shopify.com/s/files/1/1537/5553/products/01565_grande.jpg?v=1486441680',
              alt: 'Melon 2',
            },
          ],
          origin: 'France',
          isFavorite: false,
          discount: false,
          allergens: [],
          ingredients: '',
          documents: [],
          unpackedQuantity: 1,
          outer: 2,
          availabilityRefreshRate: 500,
          weight: {
            gross: '360',
            unit: 'g',
          },
          price: [
            {
              minQuantity: '0',
              maxQuantity: '100',
              price: {
                gross: '1,00',
                unit: '€',
                freeDeliveryMinimum: '200,00',
                taxes: ['0,20'],
              },
            },
          ],
          availability: {
            availability: 0,
            text: '',
          },
        },
        {
          code: '4',
          displayCode: '4',
          ean: '5 921234 123458',
          brand: 'Best',
          brandUrl: 'www.google.com',
          label: 'Tomate',
          fullLabel: 'Best Tomate',
          pictures: [
            {
              url:
                'https://www.lesfruitsetlegumesfrais.com/_upload/cache/ressources/produits/tomate/tomate_-_copie_346_346_filled.jpg',
              alt: 'Tomate',
            },
            {
              url:
                'http://www.macocotteminute.com/wp-content/uploads/2017/01/Cuisson-tomate.jpg',
              alt: 'Tomate',
            },
          ],
          origin: 'France',
          isFavorite: false,
          ingredients: '',
          discount: false,
          allergens: [],
          documents: [],
          availabilityRefreshRate: 500,
          outer: 12,
          weight: {
            gross: '102',
            unit: 'g',
          },
          price: [
            {
              minQuantity: '0',
              maxQuantity: '100',
              price: {
                gross: '1,00',
                unit: '€',
                freeDeliveryMinimum: '200,00',
                taxes: ['0,20'],
              },
            },
          ],
          availability: {
            availability: 2,
            text: '',
          },
        },
        {
          code: '5',
          displayCode: '5',
          ean: '5 921234 123458',
          brand: 'Best',
          brandUrl: 'www.google.com',
          label: 'Choux',
          fullLabel: 'Best Choux',
          pictures: [
            {
              url:
                'http://www.temps-de-cuisson.fr/wp-content/uploads/2016/09/cuisson-choux.jpg',
              alt: 'Choux',
            },
          ],
          origin: 'France',
          isFavorite: false,
          discount: false,
          availabilityRefreshRate: 500,
          allergens: [],
          documents: [],
          ingredients: '',
          outer: 2,
          unpackedQuantity: 7,
          weight: {
            gross: '178',
            unit: 'g',
          },
          price: [
            {
              minQuantity: '0',
              maxQuantity: '100',
              price: {
                gross: '1,00',
                unit: '€',
                freeDeliveryMinimum: '200,00',
                taxes: ['0,20'],
              },
            },
          ],
          availability: {
            availability: 1,
            text: '',
          },
        },
      ],
      id: "fresh",
      searchWord:'',
    },
    {
      label: 'Produits congelés',
      products: [],
      id: "frozen",
      searchWord: '',
    },
  ];
  //#endregion

  constructor(private http: HttpClient, private cacheService: CacheService) {}

  public getCatalogs(
    companyCode: string,
    customerCode: string,
    orderCode?: string,
    offerCode?: string,
    productCode?: string,
    skipLoading = false
  ): Observable<Catalog[]> {
    if (environment.useMock) {
      return of(this.catalogsMock).pipe(delay(200));
    }

    const params = {
      customerCode: customerCode,
      orderCode: orderCode,
      offerCode: offerCode,
      productCode: productCode,
      skipLoading,
      timestamp: this.cacheService.getTimestamp(),
    };

    // Remove unnecessary keys
    Object.keys(params).forEach(key => {
      if (!params[key]) {
        delete params[key];
      }
    });

    return this.http.get<Catalog[]>(
      `${this.baseUrl}/companies/${companyCode}/catalogs`,
      { params: params }
    );
  }
}
